import KibanaFilterModel from './osd-filter-model';
export default class GreaterThanFilterModel extends KibanaFilterModel {
    range;
    constructor(metadata) {
        super(metadata);
        const [from, to] = metadata.value.split('to').map(item => Number(item));
        if (!metadata.key)
            return;
        this.range = {
            [metadata.key]: {
                gte: isNaN(from) ? null : from,
                lt: null,
            },
        };
    }
}
//# sourceMappingURL=greater-than-filter-model.js.map